import { render, staticRenderFns } from "./Studyroom.vue?vue&type=template&id=4668b366&scoped=true&"
import script from "./Studyroom.vue?vue&type=script&lang=js&"
export * from "./Studyroom.vue?vue&type=script&lang=js&"
import style0 from "./Studyroom.vue?vue&type=style&index=0&id=4668b366&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4668b366",
  null
  
)

export default component.exports